// HourUserCont Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class HourUserCont extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bExpand: false
    }
  }

  static get propTypes () {
    return {
      user: PropTypes.object,
      onClickItem: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      user: {},
      onClickItem: null
    }
  }

  render () {
    const user = this.props.user
    const _className = user.expanded ? 'useritem expanded' : 'useritem'

    return (
      <div className={_className}>
        {this._renderHeader(user)}
        {this._renderActivities(user)}
      </div>
    )
  }

  /* Event handlers */
  _onToggleExpand (bExpand, user, ev) {
    ev.preventDefault()
    user.expanded = bExpand

    this.setState({ dataDate: new Date() })
  }

  _onClickUserItem (item, ev) {
    ev.preventDefault()

    if (this.props.onClickItem) {
      this.props.onClickItem(item)
    }
  }

  /* Private Function */
  _renderHeader (user) {
    return (
      <div className='userheader'>
        <div className='userheader-inner'>
          {user.noActivities > 0 && user.expanded && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, false, user)}
            >
              <i className='icon icon-planner-accordionclose' />
            </span>
          )}
          {user.noActivities > 0 && !user.expanded && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, true, user)}
            >
              <i className='icon icon-planner-accordionopen' />
            </span>
          )}
          <div
            className='cont'
            onClick={this._onClickUserItem.bind(this, user)}
          >
            <div className='itemcol coltitle'>
              <span className='imagewrap'>
                <img src={user.imageUrl} alt='' className='inline-image' />
              </span>
              {user.name}
              <span className='rate active'>
                ({<PriceText value={user.rate} />})
              </span>
            </div>
            <div className='itemcol colactivity'>{user.noActivities}</div>
            <div className='itemcol colspent'>
              <span className='spent'>
                <PriceText value={user.spentAmount || 0} />
              </span>
            </div>
            <div className='itemcol colplanned'>
              {Util.convertMinutesToHour(user.plannedHours * 60)}
            </div>
            <div className='itemcol coltracked'>
              {Util.convertMinutesToHour(user.trackedHours * 60)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderActivities (user) {
    if (!user.activities) {
      return ''
    }

    return user.activities.map((activity, idx) =>
      this._renderActivity(activity, idx)
    )
  }

  _renderActivity (activity, idx) {
    return (
      <div
        className='useractivity'
        onClick={this._onClickUserItem.bind(this, activity)}
        key={idx}
      >
        <div className='useractivity-inner'>
          <div className='cont'>
            <div className='itemcol coltitle'>
              <span className='titleinfo'>
                {activity.phaseTitle}
                <span className='split' />
                {activity.title}
              </span>
              {!activity.bUseTotal ? (
                <span className='rate active'>
                  ({<PriceText value={activity.rate} />})
                </span>
              ) : (
                <span className='rate'>
                  <IntlMessage ident='project.viewHour.userRateApplied' />
                </span>
              )}
            </div>
            <div className='itemcol colactivity' />
            <div
              className={`itemcol colspent${
                activity.total > 1000000 ? ' coltextsmall' : ''
              }`}
            >
              {activity.spentAmount > 0 && (
                <span className='spent'>
                  <PriceText value={activity.spentAmount} />
                </span>
              )}
            </div>
            <div className='itemcol colplanned'>
              {Util.convertMinutesToHour(activity.plannedHours * 60)}
            </div>
            <div className='itemcol coltracked'>
              {Util.convertMinutesToHour(activity.trackedHours * 60)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HourUserCont
